import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import formatDate from "../../utils/formatDate";

const CancelSessionModal = ({
  show,
  onHide,
  selectedSessionForCancel,
  cancellationReason,
  setCancellationReason,
  handleConfirmCancel,
  cancellationReasons,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cancel Session</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ textAlign: "left" }}>Please select a reason for cancellation:</p>
        <Form.Select
          value={cancellationReason}
          onChange={(e) => setCancellationReason(e.target.value)}
          style={{ marginTop: "12px" }}>
          <option value="">Select a reason</option>
          {cancellationReasons.map((reason) => (
            <option key={reason} value={reason}>
              {reason}
            </option>
          ))}
        </Form.Select>
        {selectedSessionForCancel && (
          <div style={{ backgroundColor: "#F8FAFC", padding: "12px", borderRadius: "8px", marginTop: "12px" }}>
            <p style={{ margin: "4px 0", textAlign: "left" }}>
              <strong>Session ID:</strong> {selectedSessionForCancel.appointment_id || selectedSessionForCancel._id}
            </p>
            <p style={{ margin: "4px 0", textAlign: "left" }}>
              <strong>Client:</strong> {selectedSessionForCancel?.user?.firstname} {selectedSessionForCancel?.user?.lastname}
            </p>
            <p style={{ margin: "4px 0", textAlign: "left" }}>
              <strong>Date:</strong> {selectedSessionForCancel.appointmenttime ? formatDate(selectedSessionForCancel.appointmenttime, "date") : "N/A"}
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirmCancel} disabled={!cancellationReason}>
          Confirm Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelSessionModal;

